// Constants
import {
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  CUSTOMER_SUCCESS,
  SEND_VERIFICATION_ATTEMPT,
  CLEAR_PHONE_VERIFICATION,
  CUSTOMER_RESPONSE_ERROR,
  CUSTOMER_FORM_ERROR,
  CLEAR_CUSTOMER_ERROR,
  CUSTOMER_CONFIRMED_SUCCESS,
  APPLICANT_RESPONSE_ERROR,
  USER_DATA_SUCCESS,
  SET_USER_CREDS,
  DELETE_USER_CREDS,
  REQUEST_MFA_CODE_REQUEST,
  REQUEST_MFA_CODE_SUCCESS,
  REQUEST_MFA_CODE_FAILURE,
  RESET_STORED_DATA
} from '../constants'

import { phone } from '@utils/format'

export type CustomerData = {
  forename: string
  surname: string
  email: string
  market_id: string
  phone: string
  verified: string
  is_applicant: boolean
  phone_verified: string
  phone_unverified: string
}

export type UserMFA = {
  userCreds: {
    email?: string
    password?: string
  }
  isLoading: boolean
  error: any
  contactOptions: any[]
  sentText: string
}

export type UserState = {
  token: string
  error: any
  isLoading: boolean
  data?: CustomerData
  mfa: UserMFA
  confirmed: boolean
  signedIn: boolean
}

export const initialState: UserState = {
  token: '',
  error: undefined,
  isLoading: false,
  data: undefined,
  mfa: {
    userCreds: {},
    isLoading: false,
    error: null,
    contactOptions: [],
    sentText: ''
  },
  confirmed: false,
  signedIn: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET_STORED_DATA: {
      return {
        ...initialState
      }
    }

    case SIGN_IN_SUCCESS: {
      return {
        ...state,
        token: action.token,
        isLoading: false
      }
    }

    case SIGN_IN_FAILURE: {
      return {
        ...state,
        isLoading: false
      }
    }

    case SIGN_IN_REQUEST: {
      return {
        ...state,
        isLoading: true
      }
    }

    case SET_USER_CREDS: {
      return {
        ...state,
        isLoading: false,
        mfa: {
          ...state.mfa,
          userCreds: action.userCreds
        }
      }
    }

    case DELETE_USER_CREDS: {
      return {
        ...state,
        mfa: {
          ...state.mfa,
          userCreds: {}
        }
      }
    }

    case REQUEST_MFA_CODE_REQUEST: {
      return {
        ...state,
        mfa: {
          ...state.mfa,
          isLoading: true
        }
      }
    }

    case REQUEST_MFA_CODE_SUCCESS: {
      const data = action.response?.data
      return {
        ...state,
        mfa: {
          ...state.mfa,
          sentText: data?.description,
          contactOptions: data?.contact_options,
          isLoading: false
        }
      }
    }

    case REQUEST_MFA_CODE_FAILURE: {
      return {
        ...state,
        mfa: {
          ...state.mfa,
          error: action.error,
          isLoading: false
        }
      }
    }

    case CLEAR_PHONE_VERIFICATION:
    case SEND_VERIFICATION_ATTEMPT: {
      return {
        ...state,
        error: undefined,
        codeSent: false
      }
    }

    case CUSTOMER_CONFIRMED_SUCCESS: {
      const { data } = action

      return {
        ...state,
        error: undefined,
        confirmed: true,
        data
      }
    }

    case USER_DATA_SUCCESS: {
      return {
        ...state,
        error: undefined,
        signedIn: action.accountId
      }
    }

    case CUSTOMER_SUCCESS: {
      const { data } = action

      return {
        ...state,
        error: undefined,
        isLoading: false,
        data
      }
    }

    case CUSTOMER_FORM_ERROR:
    case CUSTOMER_RESPONSE_ERROR: {
      const { error } = action

      return {
        ...state,
        isLoading: false,
        error
      }
    }

    case APPLICANT_RESPONSE_ERROR:
    case CLEAR_CUSTOMER_ERROR: {
      return {
        ...state,
        error: undefined
      }
    }

    default:
      return state
  }
}

const customer = state => selectCustomer(state) || {}

export const selectToken = ({ user }) => user.token
export const selectCustomer = ({ user }) => user.data
export const selectSignedIn = ({ user }) => user.signedIn
export const selectConfirmed = ({ user }) => user.confirmed
export const selectUserError = ({ user }) => user.error
export const selectUserLoading = ({ user }) => user.isLoading

export const selectPhone = state => phone(customer(state).phone)
export const selectIsRunner = state => customer(state).verified === '1'
export const selectInprogress = state => customer(state).is_applicant || false
export const selectPhoneVerified = state => customer(state).phone_verified === '1'
export const selectUnverifiedPhone = state => phone(customer(state).phone_unverified)

export const selectMfaUserCreds = state => state.user.mfa.userCreds
export const selectMfaError = state => state.user.mfa.error
export const selectIsMfaCodeLoading = state => state.user.mfa.isLoading
export const selectMfaContactOptions = state => state.user.mfa.contactOptions
export const selectMfaSentText = state => state.user.mfa.sentText

export const selectCustomerErrorStatus = ({ user: { error } }) => (error || {}).status
export const selectCustomerErrorMessage = ({ user: { error } }) => (error || {}).message
export const selectCustomerErrorWarnings = ({ user: { error } }) => (error || {}).warnings
